import apiLogSystem from "@utils/api/api_log_system";
import {
	UserEventDTO,
	UserLoginEventDTO,
	UserLoginPageDTO,
} from "@utils/api/analytics/user-event.dto";

// apiLogSystem 的 response interceptor 會 return res.data，型別在這裡修正回實際內容
export interface LogLoginResponse {
	jwt?: string;
}

// from = 流量來源（桌布活動用：liff / 國家代碼 / hk），由呼叫端帶入
export type LogEventInput = UserEventDTO & { from?: string };

/**
 * 桌布活動「數據 log system」的 API（打 REACT_APP_ANALYTICS_LOG_SYSTEM_API_URL）。
 * 與會員中心的 UserEventApi（apiAnalytics）分開，token 也各自獨立。
 */
export namespace LogSystemApi {
	export async function loginEvent(
		data: UserLoginEventDTO,
	): Promise<LogLoginResponse> {
		return apiLogSystem.post(
			"/liff/login",
			data,
		) as unknown as Promise<LogLoginResponse>;
	}

	export async function logPage(data: UserLoginPageDTO) {
		return apiLogSystem.post("/log/page", data);
	}

	export async function logEvent(data: LogEventInput) {
		return apiLogSystem.post("/log/event", data);
	}
}
